// styles
import {
    CriticalText
} from './CriticalMessage.styles.js';

export default function CriticalMessage({ text, color = 'white' }) {
  return (
    <CriticalText color={color}>{text}</CriticalText>
  )
}
